import styled from 'styled-components';
import { Card, CardContent, Typography } from '@material-ui/core';
import OpenInNew from '@material-ui/icons/OpenInNew';
import { COLORS } from 'constants/design';

export const Container = styled.main`
  .contester-button {
    margin-right: 20px;
  }
  background-color: transparent;
  .subContainer {
    justify-content: space-around;
    margin-top: 25px;
  }
  .upload-document-button {
    font-weight: normal;
    font-size: 14px;
    width: 100%;
  }
  .validate-button {
    margin-right: 20px;
  }
  .errorSelect {
    margin-top: 9px;
    color: red;
  }
`;

export const StyledTitleTypography = styled(Typography)`
  font-size: 12px;
  color: ${COLORS.ACCORDION_GRAY};
`;
export const SahamTabsGlobal = styled.div`
  background-color: #fff;
  margin-top: 20px;
  .MuiTabs-flexContainer {
    display: flex;
    align-items: center;
    background-color: transparent;
  }
`;
export const JudgementAddDecisionStyle = styled.div`
  position: absolute;
  right: 234px;
  margin-top: -63px;
`;

export const OpenInNewIcon = styled(OpenInNew)`
  font-size: 1.2em;
  margin-bottom: -3px;
`;

export const StyledCard = styled(Card)`
  padding-left: 16px;
`;

export const StyledCardContent = styled(CardContent)`
  padding: 0px;
  .MuiChip-label {
    margin-top: 2px;
  }
`;

export const StyledGrid = styled.div`
  position: absolute;
  right: 64px;
  margin-top: -40px;
  height: 50px;
`;
export const StyledGridButton = styled.div`
  position: absolute;
  right: 250px;
  margin-top: -15px;
  height: 50px;
`;
export const StyledDiv = styled.div`
  margin-top: 40px;
  width: 350px;
`;

export const StyledTopDiv = styled.div`
  margin-top: 50px;
`;

export const StyledCivilProceedingDropDown = styled.div`
  width: 70%;
  min-height: 43px;
  background: #fbfbfb 0% 0% no-repeat padding-box;
  border-radius: 4px;
  padding: 2px;
  margin-top: 60px;

  .drop-down-icon {
    fill: #212121;
  }
  .drop-down-button {
    font-size: 15px;
    justify-content: space-between;
    width: 100%;
    font-weight: 600;
    color: #212121;
    text-transform: none;
    opacity: 1;
    letter-spacing: 0.02px;
  }
  .popper {
    margin-top: 5px;
    transform: translate3d(0px, 40px, 0px);
    min-width: 238px;
    z-index: 100;
    background-color: #fafafa;
    box-shadow: 0px 2px 10px #00000033;
  }
`;
export const StyledDecisionDropDown = styled.div`
  width: 40px;
  min-height: 36px;
  background-color: #0075c9;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 4px;
  padding: 2px;
  .drop-down-icon {
    fill: #fff;
  }
  .drop-down-button {
    font-size: 14px;
    min-height: 36px;
    justify-content: space-between;
    min-width: 30px;
    color: #fff;
    text-transform: none;
    margin-left: 5px;
  }
  .popper {
    margin-top: 5px;
    transform: translate3d(0px, 40px, 0px);
    min-width: 145px;
    z-index: 100;
    background-color: #fafafa;
    box-shadow: 0px 2px 10px #00000033;
  }
`;
export const FormContainer = styled.div`
  margin-bottom: '10px';
  .align-right {
    text-align: right;
    padding: '30px';
  }
  .text-underlined {
    text-decoration: underline #0000ff;
    color: #0000ff;
    margin-top: 43px;
  }
  .select {
    width: 90%;
    margin-bottom: 3px;
    font-size: 13px;
  }
  .title-button {
    color: #0075c9;
    font-size: 13px;
    line-height: 15px;
    align-items: center;
    text-align: center;
  }
  .icon {
    height: 18px;
    width: 18px;
    margin-right: 7px;
    color: #0075c9;
  }
  .add-victim-btn {
    width: 160px;
    height: 36px;
    text-align: center;
    font-size: 14px;
  }
  .button-left-space {
    margin-left: 15px;
  }
  .max-content {
    width: max-content !important;
  }
  .check_box_container {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 16pxs;
  }
  .input {
    width: 100%;
    margin-right: 24px;
    margin-top: 12px;
  }
  .input-1 {
    width: 100%;
    margin-right: 24px;
  }
  .subtitle {
    margin-top: 10px;
    margin-bottom: 15px;
    font-weight: bolder;
    font-size: 16px;
  }
  .check_box_div {
    min-width: 100px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 1px 3px #0000001f;
    border-radius: 4px;
    margin-right: 16px;
    padding: 0 12px;
    text-align: center;
    font-size: 15px;
    color: black;
  }
  .title {
    font-size: 14px;
    font-weight: bold;
    color: #0075c9;
    margin-bottom: 10px;
    text-transform: uppercase;
  }
  .request-icon {
    margin-right: 10px;
    width: 25px;
    height: 19px;
  }
  .title-1 {
    font-size: 14px;
    font-weight: bold;
    color: #2b2727;
    margin-bottom: 20px;
    text-transform: uppercase;
  }
  .upload-document {
    width: 100%;
  }
  .fee-note-form {
    button {
      width: 100%;
    }
    .upload-doc-title {
      font-weight: bolder;
      font-size: 16px;
      margin-bottom: 10px;
    }
  }
  .errorSelect {
    margin-top: 9px;
    color: red;
  }
`;

export const Title = styled(Typography)`
  text-align: left;
  letter-spacing: 0;
  margin-left: 10px;
  color: #2b2727;
  font-weight: 500;
  font-family: Roboto;
`;

export const Title2 = styled(Typography)`
  text-align: left;
  color: #5d5a5a;
  font-weight: 500;
  font-size: small;
  .MuiSvgIcon-fontSizeSmall {
    font-size: 1rem;
    margin-bottom: -3px;
  }
`;

export const Title3 = styled(Typography)`
  text-align: left;
  font-weight: 500;
  font-size: small;
`;

export const RegulationHeader = styled.div`
  display: flex;
  width: 1152px;
  height: 500px;
  left: 264px;
  top: 205px;
  background: #ffffff;
  border-radius: 10px;
`;

export const RegulationContainer = styled.div``;
export const StyledDivDialog = styled.div`
  width: 549px;
  display: flex;
  flex-direction: column;
  .input {
    margin-bottom: 20px;
    font-size: 13px;
  }
`;
export const SpacingBottom = {
  marginBottom: 20,
};
export const StyledTopCard = {
  backgroundColor: 'rgba(252, 239, 236, 1)',
  padding: '8px 16px 8px 8px',
  width: '475px',
  height: '40px',
  marginBottom: 15,
};
export const StyledText = {
  color: 'rgba(255, 52, 0, 1)',
  fontSize: '14px',
  marginTop: 2,
};
